export enum AddressValidationErrorTypes {
  INVALID_SHIPPING_ADDRESS = 'INVALID_SHIPPING_ADDRESS'
}

export enum UnavailableShippingRegions {
  BALEARIC_ISLANDS = 'ES_IB'
}

export const VALIDATION_FIELDS_MAP = {
  destinationRegion: 'region',
} as const;

export const PREODER_VALIDATION_INVALID_SHIPPING = 'preorder_validation.invalid_shipping_address';